import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const versionApi = createApi({
    baseQuery: fetchBaseQuery({ baseUrl: '/api/' }),
    reducerPath: 'versionApi',
    endpoints: (builder) => ({
        versionRetrieve: builder.query<any, string>({
            query: () => `version`,
        }),
    }),
})

export const { 
    useVersionRetrieveQuery,
} = versionApi
